import React from 'react';
export function HeroSection() {
  return <div className="relative" data-id="element-4061">
      <div className="absolute inset-0" data-id="element-4062">
        <img src="https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/preview/uploaded/images/Reedesign%2007.11/Layer%2012.png" alt="Used Machine Inventory" className="block w-full h-full object-cover" data-id="element-4063" />
        <div className="absolute inset-0 bg-[#002d4d]/85" data-id="element-4064" />
      </div>
      <div className="relative max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-14 md:py-16" data-id="element-4065">
        <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white tracking-tight text-center" data-id="element-4066">
          Used Machines
        </h1>
      </div>
    </div>;
}